enum AssetFieldNames {
  AssetDetailsTitle = 'asset-details-title',
  AssetIconTitle = 'asset-icon-title',
  Category = 'category',
  CategoryDefault = 'category-default',
  Code = 'code',
  Description = 'description',
  DocumentationLinks = 'documentationLinks',
  DocumentationLinksTitle = 'documentationLinks-title',
  FullCode = 'fullCode',
  IconAttached = 'iconAttached',
  Id = 'id',
  LocationPhotoAttached = 'locationPhotoAttached',
  Manufacturer = 'manufacturer',
  Model = 'model',
  Name = 'name',
  PoorWifi = 'poorWifi',
  QrCodePrefix = 'qrCodePrefix',
  QrCodePrefixDefault = 'qrCodePrefix-default',
  SerialNumber = 'serialNumber',
  ServiceDate = 'serviceDate',
  Site = 'site',
  SiteArea = 'siteArea',
  SpecificationTitle = 'specification-title',
}

export default AssetFieldNames;
